// project-imports
import { deleteRequest, getRequest, postRequest, putRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - DEVELOPERS ||============================== //

export async function handleDevelopers(action: APIAction) {
  switch (action.method) {
    case 'list':
      return getRequest('/developers');
    case 'create':
      return postRequest('/developers', action.data);
    case 'update':
      return putRequest(`/developers/${action.id}`, action.data);
    case 'delete':
      return deleteRequest(`/developers/${action.id}`);
    default:
      console.info('[ApiManager > handleApiAction > handleDevelopers] - Unknown method');
      break;
  }
}
